/**
 * Document title updates while a scan runs in a background tab.
 */

export const DEFAULT_WORKSPACE_TITLE = 'CyberTracer — OSINT Workspace';

/**
 * @param {object} opts
 * @param {boolean} opts.hidden
 * @param {boolean} opts.scanning
 * @param {boolean} opts.completed
 * @param {number} [opts.resultsCount]
 * @param {number} [opts.elapsedSec]
 */
export function resolveScanDocumentTitle({
  hidden,
  scanning,
  completed,
  resultsCount = 0,
  elapsedSec = 0,
} = {}) {
  if (!hidden) {
    return DEFAULT_WORKSPACE_TITLE;
  }
  if (scanning) {
    const mm = String(Math.floor(elapsedSec / 60)).padStart(2, '0');
    const ss = String(elapsedSec % 60).padStart(2, '0');
    return `(⏱️ ${mm}:${ss}) SCANNING... | CyberTracer`;
  }
  if (completed) {
    return `(✅ ${resultsCount} Results) Scan Complete! | CyberTracer`;
  }
  return DEFAULT_WORKSPACE_TITLE;
}

/**
 * @param {string} title
 */
export function applyDocumentTitle(title) {
  if (typeof document === 'undefined') return;
  const next = String(title || DEFAULT_WORKSPACE_TITLE);
  if (document.title !== next) {
    document.title = next;
  }
}
